import { Layer } from '~/packages/general/variable/spaceTime.types'
import { VariableAndOptionalResult } from '~/packages/general/variable/variables.typing'

const preferredDisplayFields = ['name', 'title', 'description'] as const

export type ClusterListLayer = Omit<Layer, 'variable'> & {
  variable: VariableAndOptionalResult
}

export function isVariableLayer(layer: Layer): layer is ClusterListLayer {
  return typeof (layer.variable as VariableAndOptionalResult).actionDefinitionKey === 'string'
}

const normalizeFieldName = (field: string) =>
  field
    .replace(/([a-z0-9])([A-Z])/g, '$1 $2')
    .replace(/[._-]+/g, ' ')
    .trim()
    .toLowerCase()

const isCoordinateField = (field: string) => {
  const normalizedField = normalizeFieldName(field)

  return (
    normalizedField.includes('point on street') ||
    /\b(latitude|longitude|lat|lng)\b/.test(normalizedField)
  )
}

function normalizeSelect(layer: ClusterListLayer) {
  const allowedFields = new Set(Object.keys(layer.variable.shape?.shape ?? {}))
  const coordinateFields = Array.from(allowedFields).filter(isCoordinateField)
  const select = [
    ...(layer.variable.basicSelect ?? []),
    ...(layer.variable.detailedSelect ?? []),
    ...preferredDisplayFields,
    ...coordinateFields,
  ].filter(field => allowedFields.has(field))

  return select.length > 0 ? Array.from(new Set(select)) : undefined
}

export function buildClusterListInput(layer: ClusterListLayer) {
  return {
    variable: layer.variable,
    filter: layer.variable.filter ?? undefined,
    highlight: layer.variable.highlight ?? undefined,
    space: layer.space ?? undefined,
    time: layer.time ?? undefined,
    select: normalizeSelect(layer),
  }
}
